<template>
    <div v-if="model">
        <rkm-form
            ref="RkmForm"
            show-legend
        >
            <rkm-row>
                <rkm-col>
                    <rkm-area
                        title="Propriedades"
                        type="fieldset"
                    >
                        <rkm-row>
                            <rkm-col cols="12">
                                <rkm-form-select
                                    :options="form.parametrizacaoDescricoesVacina"
                                    :validations="validations.parametrizacaoDescricaoVacinaId"
                                    label="Descrição de vacina"
                                    text-field="nome"
                                    v-model="model.parametrizacaoDescricaoVacinaId"
                                    value-field="id"
                                />
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col cols="auto">
                                <rkm-form-checkbox inline v-model="model.perfilCampanha">
                                    Perfil de campanha
                                </rkm-form-checkbox>
                            </rkm-col>

                            <rkm-col cols="auto">
                                <rkm-form-checkbox inline v-model="model.usaUltimoFrasco">
                                    Última dose do frasco
                                </rkm-form-checkbox>
                            </rkm-col>

                            <rkm-col cols="auto">
                                <rkm-form-checkbox inline v-model="model.cnsCpfObrigatorio">
                                    CNS/CPF obrigatório
                                </rkm-form-checkbox>
                            </rkm-col>
                        </rkm-row>
                    </rkm-area>
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <rkm-area
                        title="Permitir aplicação"
                        type="fieldset"
                    >

                        <rkm-row>

                            <rkm-col cols="auto">
                                <rkm-form-checkbox inline v-model="model.aplicacaoDataRetroativa">
                                    Data retroativa
                                </rkm-form-checkbox>
                            </rkm-col>

                            <rkm-col cols="auto">
                                <rkm-form-checkbox inline v-model="model.cadastroOutroMunicipio">
                                    Outro município
                                </rkm-form-checkbox>
                            </rkm-col>

                            <rkm-col cols="auto">
                                <rkm-form-checkbox inline v-model="model.cadastroProvisorio">
                                    Provisório
                                </rkm-form-checkbox>
                            </rkm-col>

                            <rkm-col cols="auto">
                                <rkm-form-checkbox inline v-model="model.cadastroBloqueado">
                                    Cadastro bloqueado
                                </rkm-form-checkbox>
                            </rkm-col>

                            <rkm-col cols="auto">
                                <rkm-form-checkbox inline v-model="model.cadastroDesatualizado">
                                    Cadastro desatualizado
                                </rkm-form-checkbox>
                            </rkm-col>
                        </rkm-row>
                    </rkm-area>
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <rkm-area
                        title="Aprazamento"
                        type="fieldset"
                    >
                        <rkm-row>
                            <rkm-col cols="2">
                                <rkm-form-input
                                    :disabled="!model.aprazamentoAtivo"
                                    :validations="validations.aprazamentoDiasAntes"
                                    label="Dias antes"
                                    type="number"
                                    v-model="model.aprazamentoDiasAntes"
                                />
                            </rkm-col>

                            <rkm-col cols="2">
                                <rkm-form-input
                                    :disabled="!model.aprazamentoAtivo"
                                    :validations="validations.aprazamentoDiasDepois"
                                    label="Dias depois"
                                    type="number"
                                    v-model="model.aprazamentoDiasDepois"
                                />
                            </rkm-col>

                            <rkm-col cols="2">
                                <rkm-form-checkbox
                                    :label="false"
                                    @change="handleAprazamentoAtivoChange"
                                    v-model="model.aprazamentoAtivo"
                                >
                                    Ativo
                                </rkm-form-checkbox>
                            </rkm-col>
                        </rkm-row>
                    </rkm-area>
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <BoxIntegracaoAplicativo :data="{model: model.integracaoAplicativo}" />
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <rkm-row>
            <rkm-col>
                <rkm-area
                    title="Lista de CBOs"
                    type="fieldset"
                >
                    <rkm-form ref="FormOcupacao">
                        <rkm-row>
                            <rkm-col class="flex-grow-1">
                                <rkm-form-input-autocomplete
                                    :repository="repositories.ocupacao"
                                    :search-fields="fields.autocomplete.ocupacao"
                                    :text-field="(item) => `${item.codigo} - ${item.nome}`"
                                    :validations="validations.ocupacao"
                                    label="CBO"
                                    placeholder="Digite o código ou nome do CBO"
                                    v-model="local.ocupacao"
                                />
                            </rkm-col>

                            <rkm-col cols="auto">
                                <rkm-button
                                    :label="false"
                                    @click="includeOcupacao"
                                    color="primary"
                                >
                                    Incluir
                                </rkm-button>

                                <rkm-button
                                    :disabled="!local.ocupacao"
                                    :label="false"
                                    @click="resetFormOcupacao"
                                >
                                    Limpar
                                </rkm-button>
                            </rkm-col>
                        </rkm-row>
                    </rkm-form>

                    <rkm-row>
                        <rkm-col cols="12">
                            <rkm-table
                                :fields="fields.table.ocupacao"
                                :items="model.ocupacoes"
                            >
                                <template v-slot:cell(ocupacao)="row">
                                    {{ row.item.codigo }} - {{ row.item.nome }}
                                </template>

                                <template v-slot:cell(actions)="{ index }">
                                    <rkm-button
                                        @click="destroyOcupacao(index)"
                                        color="danger"
                                        small
                                        title="Excluir"
                                    >
                                        <rkm-icon icon="trash" />
                                    </rkm-button>
                                </template>
                            </rkm-table>
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <rkm-area
                    title="Lista de supervisores"
                    type="fieldset"
                >
                    <rkm-form ref="FormSupervisor">
                        <rkm-row>
                            <rkm-col>
                                <rkm-form-input-autocomplete
                                    :repository="repositories.usuario"
                                    :search-fields="fields.autocomplete.usuario"
                                    :text-field="(item) =>  item.cidadaoNome"
                                    :validations="validations.usuario"
                                    label="Profissional"
                                    v-model="local.usuario"
                                />
                            </rkm-col>

                            <rkm-col cols="3">
                                <rkm-form-select
                                    :options="form.unidades"
                                    :validations="validations.unidadeId"
                                    @change="handleUnidadeIdChange"
                                    label="Unidade"
                                    show-default-option
                                    text-field="nomeFantasia"
                                    v-model="local.unidadeId"
                                    value-field="id"
                                />
                            </rkm-col>

                            <rkm-col cols="3">
                                <rkm-form-select
                                    :options="form.salasVacinacao"
                                    :validations="validations.salaVacinacaoId"
                                    label="Local de atendimento"
                                    show-default-option
                                    text-field="nome"
                                    v-model="local.salaVacinacaoId"
                                    value-field="id"
                                />
                            </rkm-col>

                            <rkm-col cols="auto">
                                <rkm-button
                                    :label="false"
                                    @click="includeSupervisor"
                                    color="primary"
                                >
                                    Incluir
                                </rkm-button>

                                <rkm-button
                                    :disabled="!local.usuario && !local.unidadeId && !local.salaVacinacaoId"
                                    :label="false"
                                    @click="resetFormSupervisor"
                                >
                                    Limpar
                                </rkm-button>
                            </rkm-col>
                        </rkm-row>
                    </rkm-form>

                    <rkm-row>
                        <rkm-col cols="12">
                            <rkm-table
                                :fields="fields.table.usuario"
                                :items="model.supervisores"
                            >
                                <template v-slot:cell(usuario)="row">
                                    {{ row.item.codigo }} - {{ row.item.nome }}
                                </template>

                                <template v-slot:cell(actions)="{ index }">
                                    <rkm-button
                                        @click="destroySupervisor(index)"
                                        color="danger"
                                        small
                                        title="Excluir"
                                    >
                                        <rkm-icon icon="trash" />
                                    </rkm-button>
                                </template>
                            </rkm-table>
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>
        </rkm-row>
    </div>
</template>

<script>
// Mixins.
import { error, formats, repository, stringCase } from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

// Components.
import BoxIntegracaoAplicativo from './components/integracao-aplicativo/Form'

export default {
    components: {
        BoxIntegracaoAplicativo,
    },
    computed: {
        fields() {
            return {
                autocomplete: {
                    ocupacao: [
                        { key: 'codigo', searchable: true },
                        { key: 'nome', searchable: true },
                    ],
                    usuario: [
                        { key: 'cadastroCidadao.nome', searchable: true },
                    ],
                },
                table: {
                    ocupacao: [
                        { key: 'ocupacao', label: 'CBO' },
                        { key: 'actions', label: 'Ações', class: 'col-min text-center' },
                    ],
                    usuario: [
                        { key: 'usuarioNome', label: 'Profissional' },
                        { key: 'unidadeNomeFantasia', label: 'Unidade' },
                        { key: 'salaVacinacaoNome', label: 'Local de atendimento' },
                        { key: 'actions', label: 'Ações', class: 'col-min text-center' },
                    ],
                },
            }
        },
        validations() {
            return {
                parametrizacaoDescricaoVacinaId: { required: true },
                aprazamentoDiasAntes: {
                    required: true,
                    min_value: this.model.aprazamentoDiasDepois == 0 ? 1 : 0,
                    max_value: 365,
                },
                aprazamentoDiasDepois: {
                    required: true,
                    min_value: this.model.aprazamentoDiasAntes == 0 ? 1 : 0,
                    max_value: 365,
                },
                ocupacao: { required: true },
                usuario: { required: true },
                unidadeId: { required: true },
                salaVacinacaoId: { required: true },
            }
        },
    },
    created() {
        this.repositories = {
            ocupacao: this.getConectaSusRepository('sigtap.ocupacao'),
            parametrizacao: this.getConectaSusRepository('imunizacao.parametrizacao'),
            usuario: this.getConectaSusRepository('cadastro.sujeitoAtencao.usuario'),
        }
    },
    data: () => ({
        form: null,
        local: {
            ocupacao: null,
            usuario: null,
            unidadeId: null,
            salaVacinacaoId: null,
        },
        model: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            this.repositories.parametrizacao.create()
                .then(response => {
                    this.form = Object.assign(response.data.form)
                    this.model = Object.assign(response.data.model)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleAprazamentoAtivoChange() {
            this.model.aprazamentoDiasAntes = null
            this.model.aprazamentoDiasDepois = null
        },
        handleUnidadeIdChange(id) {
            this.local.salaVacinacaoId = null

            const request = {
                listar: 'salas_vacinacao',
                unidadeId: id
            }

            this.setLoading()

            this.repositories.parametrizacao.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.salasVacinacao = Object.assign(response.data)

                    if (this.form.salasVacinacao.length === 1) {
                        const selected = this.form.salasVacinacao[0]
                        this.local.salaVacinacaoId = selected.id
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        includeOcupacao() {
            this.$refs.FormOcupacao.validate()
                .then(valid => {
                    if (valid === false) return

                    if (this.model.ocupacoes.find(ocupacao => ocupacao.id === this.local.ocupacao.id)) {
                        this.showValidationNotification('O CBO seleciona já foi incluído.')
                        return
                    }

                    this.model.ocupacoes.push({
                        id: this.local.ocupacao.id,
                        codigo: this.local.ocupacao.codigo,
                        nome: this.local.ocupacao.nome,
                    })

                    this.resetFormOcupacao()
                })
        },
        includeSupervisor() {
            this.$refs.FormSupervisor.validate()
                .then(valid => {
                    if (valid === false) return

                    if (
                        this.model.supervisores.find(usuario => usuario.usuarioId === this.local.usuario.id && usuario.salaVacinacaoId === this.local.salaVacinacaoId)
                    ) {
                        this.showValidationNotification('O profissional selecionado já foi incluído.')
                        return
                    }

                    const unidade = this.form.unidades.find(unidade => unidade.id === this.local.unidadeId)
                    const salaVacinacao = this.form.salasVacinacao.find(salaVacinacao => salaVacinacao.id === this.local.salaVacinacaoId)

                    this.model.supervisores.push({
                        usuarioId: this.local.usuario.id,
                        usuarioNome: this.local.usuario.cidadaoNome,
                        unidadeId: unidade.id,
                        unidadeNomeFantasia: unidade.nomeFantasia,
                        salaVacinacaoId: salaVacinacao.id,
                        salaVacinacaoNome: salaVacinacao.nome,
                    })

                    this.resetFormSupervisor()
                })
        },
        resetFormOcupacao() {
            this.local.ocupacao = null
            this.$refs.FormOcupacao.resetValidator()
        },
        resetFormSupervisor() {
            this.local.usuario = null
            this.local.unidadeId = null
            this.local.salaVacinacaoId = null
            this.$refs.FormSupervisor.resetValidator()
        },
        destroyOcupacao(index) {
            this.showDeleteConfirmation('Deseja realmente excluir o CBO?', async () => this.model.ocupacoes.splice(index, 1))
        },
        destroySupervisor(index) {
            this.showDeleteConfirmation('Deseja realmente excluir o profissional?', async () => this.model.supervisores.splice(index, 1))
        },
        save() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    this.setLoading()

                    const request = {
                        parametrizacaoDescricaoVacinaId: this.model.parametrizacaoDescricaoVacinaId,
                        perfilCampanha: this.model.perfilCampanha,
                        usaUltimoFrasco: this.model.usaUltimoFrasco,
                        cnsCpfObrigatorio: this.model.cnsCpfObrigatorio,
                        aprazamentoDiasAntes: this.model.aprazamentoDiasAntes,
                        aprazamentoDiasDepois: this.model.aprazamentoDiasDepois,
                        aprazamentoAtivo: this.model.aprazamentoAtivo,
                        aplicacaoDataRetroativa: this.model.aplicacaoDataRetroativa,
                        cadastroOutroMunicipio: this.model.cadastroOutroMunicipio,
                        cadastroProvisorio: this.model.cadastroProvisorio,
                        cadastroBloqueado: this.model.cadastroBloqueado,
                        cadastroDesatualizado: this.model.cadastroDesatualizado,
                        ocupacoes: this.model.ocupacoes.map(ocupacao => {
                            return  {
                                ocupacaoId: ocupacao.id,
                            }
                        }),
                        supervisores: this.model.supervisores.map(supervisor => {
                            return {
                                usuarioId: supervisor.usuarioId,
                                salaVacinacaoId: supervisor.salaVacinacaoId,
                            }
                        }),
                        integracaoAplicativo: this.model.integracaoAplicativo,
                    }

                    this.repositories.parametrizacao.store(this.camelObjectKeysToSnakeRecursive(request))
                        .then(response => {
                            this.resetFormOcupacao()
                            this.resetFormSupervisor()
                            this.$refs.RkmForm.resetValidator()
                            this.showSaveNotification()
                            this.$emit('save', response)
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
    },
    mixins: [ error, formats, repository, stringCase ],
    mounted() {
        this.load()
    },
    watch: {
        'local.usuario': {
            deep: true,
            handler() {
                this.form.salasVacinacao = []
                this.local.unidadeId = null
                this.local.salaVacinacaoId = null
            }
        },
    },
}
</script>